import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import { AuthProvider } from "@/context/AuthContext";

import "@/index.css";

const Services = lazy(() => import("@/pages/Services"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const About = lazy(() => import("@/pages/About"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const Contact = lazy(() => import("@/pages/Contact"));
const GiftVoucher = lazy(() => import("@/pages/GiftVoucher"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{
              style: {
                background: "#0B0B0B",
                color: "#F7E7CE",
                border: "1px solid rgba(247,231,206,0.18)",
                fontFamily: "Poppins, sans-serif",
              },
            }}
          />
          <Suspense fallback={<div className="min-h-screen bg-cream" />}>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/hizmetler" element={<Services />} />
                <Route path="/hizmetler/:slug" element={<ServiceDetail />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/galeri" element={<Gallery />} />
                <Route path="/hediye-ceki" element={<GiftVoucher />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
